<template lang="pug">
.container-restricao
    div(
        v-if='restricoes.length > 0',
        v-for='(restricao, index) in listaRestricoes'
    )
        .card-restricao
            .container-restricao-acoes(
                v-if='existeDadosGeoEspaciais(restricoes[index])'
            )
                div
                    el-button(
                        size='small',
                        icon='mdi mdi-crosshairs-gps',
                        @click='aplicarZoomRestricao(index)'
                    )
            p
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.numeroTAD') }}:
                |
                | {{ restricao.num_tad || '-' }}

                br

                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.numeroAI') }}:
                |
                | {{ restricao.num_ai || '-' }}

                br

                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.cnpjAutuado') }}:
                |
                | {{ restricao.cpf_cnpj || '-' }}

                br

                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.autuado') }}:
                |
                | {{ restricao.nome || '-' }}

                br

                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.processoAdministrativo') }}:
                |
                | {{ restricao.proc_admin || '-' }}

                br

                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.cnpjAutuado') }}:
                |
                | {{ restricao.cpf_cnpj || '-' }}

                br

                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.autuado') }}:
                |
                | {{ restricao.nome || '-' }}

                br

                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.ano') }}:
                |
                | {{ restricao.ano || '-' }}

                br

                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.municipio') }}:
                |
                | {{ restricao.mun || '-' }}

                br

                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.uf') }}:
                |
                | {{ restricao.uf || '-' }}

                br

                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.endereco') }}:
                |
                | {{ restricao.endereco || '-' }}

                br

                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.localizacao') }}:
                |
                | {{ restricao.localizacao || '-' }}

                br

                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.julgamento') }}:
                |
                | {{ restricao.julgamento || '-' }}

                br

                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.infracao') }}:
                |
                | {{ restricao.infracao || '-' }}

                br

                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.dataLista') }}:
                |
                | {{ formatarData(restricao.dt_lista) }}

                br

                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.dataEmbargo') }}:
                |
                | {{ formatarData(restricao.dt_embargo) }}

                br

                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.dataAtualizacao') }}:
                |
                | {{ formatarData(restricao.dt_atualizacao) }}
</template>
<script>
import { formatarData } from '@/utils/filters';

export default {
    name: 'area-embargada-sedam-ro',
    props: {
        restricoes: {
            type: Array,
            required: true
        },
        geometria: {
            type: Array,
            required: false,
            default: null
        },
        habilitarZoomRestricao: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data() {
        return {};
    },

    computed: {
        listaRestricoes: function () {
            return this.restricoes.map(value => {
                if (value.properties) {
                    return {
                        ...value.properties
                    };
                }
                return value;
            });
        }
    },

    methods: {
        formatarData,
        aplicarZoomRestricao(index) {
            let geometriaQueNaoEstavaDentroDasRestricoes = null;
            if (this.geometria) {
                geometriaQueNaoEstavaDentroDasRestricoes =
                    this.geometria[index];
            }
            this.$emit(
                'aplicar-zoom-restricao',
                this.restricoes[index],
                geometriaQueNaoEstavaDentroDasRestricoes,
                index
            );
        },
        existeDadosGeoEspaciais(restricao) {
            const { geometry, geometria, properties } = restricao;

            if (properties?.latitude && properties?.longitude) {
                return true;
            }

            return (
                this.habilitarZoomRestricao &&
                (geometry || geometria || this.geometria)
            );
        }
    }
};
</script>
